import { render, staticRenderFns } from "./milestone-form-footer-delete-button.vue?vue&type=template&id=660cadcf&scoped=true&"
import script from "./milestone-form-footer-delete-button.vue?vue&type=script&lang=ts&"
export * from "./milestone-form-footer-delete-button.vue?vue&type=script&lang=ts&"
import style0 from "./milestone-form-footer-delete-button.vue?vue&type=style&index=0&id=660cadcf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "660cadcf",
  null
  
)

export default component.exports